// redux/reducers/activityReducer.ts
import { ActionType } from '../../util/model'; // Import action types

const initialState = {
  loading: false,
  data: null,
  error: null,

  allActivities: null,       // Stores activity list
  totalActivities: 0,        // Stores total activity count
  allActivitiesLoading: false,
  allActivitiesError: null,

  spentTime: null,
  spentTimeLoading: false,
  spentTimeError: null,
};

export const activityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionType.ACTIVITY_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case ActionType.ACTIVITY_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };

    case ActionType.ACTIVITY_STATUS_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };

    // Handling the request, success, and failure for all activities
    case ActionType.ACTIVITY_STATUS_REQUEST_ALL:
      return { ...state, allActivitiesLoading: true, allActivitiesError: null };

    case ActionType.ACTIVITY_STATUS_SUCCESS_ALL:
      return { 
        ...state, 
        allActivitiesLoading: false, 
        allActivities: action.payload, // Store only activities
        totalActivities: action.payload.totalActivities, // Store total count separately
        allUserLastActivity: action.payload.UserLastActivity,
        hoursOnEachPageByUser: action.payload.hoursOnEachPageByUser,
        allActivitiesError: null 
      };

    case ActionType.ACTIVITY_STATUS_FAILURE_ALL:
      return { 
        ...state, 
        allActivitiesLoading: false, 
        allActivities: null, 
        totalActivities: 0, 
        allUserLastActivity: null,
        allActivitiesError: action.payload
      };

    // Spent Time Actions
    case ActionType.ACTIVITY_SPENT_TIME_REQUEST:
      return { ...state, spentTimeLoading: true, spentTimeError: null };

    case ActionType.ACTIVITY_SPENT_TIME_SUCCESS:
      return { 
        ...state, 
        spentTimeLoading: false, 
        spentTime: action.payload, 
        spentTimeError: null 
      };

    case ActionType.ACTIVITY_SPENT_TIME_FAILURE:
      return { 
        ...state, 
        spentTimeLoading: false, 
        spentTime: null, 
        spentTimeError: action.payload 
      };

    default:
      return state;
  }
};
